import { Component, Vue } from 'vue-property-decorator';
import { remove, findIndex } from 'lodash';
import Axios from 'axios';

@Component
export default class FileUtil extends Vue {
  /**
   * Parses the items, row id, itemUpdate and returns updated items list
   * @param items
   * @param id
   * @param itemUpdate
   */
  public updateItem(items: any, id: any, itemUpdate: any) {
    const tempItems = [...items];
    const index = findIndex(tempItems, { id });
    tempItems.splice(index, 1, { ...itemUpdate });
    return tempItems;
  }

  /**
   * Parses the items, row id and returns deleted items list
   * @param items
   * @param id
   */
  public deleteItem(items: any, id: any) {
    const tempItems = [...items];
    remove(tempItems, item => item.id === id);
    return tempItems;
  }

  /**
   * Parses the object and returns download file
   * @param file
   */
  public downloadStaticFile(file: any) {
    const { name, url: urlFile } = file;
    Axios({
      url: urlFile,
      method: 'GET',
      responseType: 'blob',
    }).then((response: any) => {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', name);
      document.body.appendChild(fileLink);
      fileLink.click();
      document.body.removeChild(fileLink);
    });
  }

  /**
   * Parses the file to download it
   * @param base64Encoded
   * @param fileName
   */
  public downloadDocument(base64Encoded: any, fileName: any) {
    const fileLink = window.document.createElement('a');
    fileLink.href = base64Encoded;
    fileLink.download = fileName;
    document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(fileLink);
  }

  /**
   * Parses the file and returns encoded string
   * @param file
   */
  public getBase64Encoded(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
}
